<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <u-icon>Ù</u-icon>
      </div>
      <div>
        <div><span>{{ $t('app.ernestHeader.questionnaireDetail') }}</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest">
      <h1>{{ title }}</h1>

      <v-text-field v-model="newQuestionnaire.label"
                    :label="$t('pages.questionnaireSettings.label')"
                    color="valid"
      />
      <v-textarea v-model="newQuestionnaire.description"
                  :label="$t('pages.questionnaireSettings.description')"
                  color="valid"
      />
      <div id="publication">
        <date-time-picker v-model="publicationDayAndTime"
                          :label="$t('pages.questionnaireSettings.publicationDateAndTime')"
                          :button-now-translation="$t('pages.questionnaireSettings.publicationButtonNow')"
                          format="YYYY-MM-DD HH:mm"
                          color="#47A4A9"
                          button-color="#6D98D5"
                          minute-interval="5"
        />
<!--        <v-menu v-model="datePickerDisplay"-->
<!--                :close-on-content-click="false"-->
<!--                transition="scale-transition"-->
<!--                offset-y-->
<!--                full-width-->
<!--                min-width="290px"-->
<!--        >-->
<!--          <template slot="activator" slot-scope="{ on }">-->
<!--            <v-text-field v-model="publicationDay"-->
<!--                          :label="$t('pages.questionnaireSettings.publicationDate')"-->
<!--                          prepend-icon="event"-->
<!--                          readonly-->
<!--                          v-on="on"-->
<!--                          color="valid"-->
<!--            />-->
<!--          </template>-->
<!--          <v-date-picker v-model="publicationDay"-->
<!--                         locale="fr"-->
<!--                         no-title-->
<!--                         @change="datePickerDisplay=false"-->
<!--                         color="valid"-->
<!--                         first-day-of-week="1"-->
<!--          />-->
<!--        </v-menu>-->

<!--        <v-menu v-model="timePickerDisplay"-->
<!--                :close-on-content-click="false"-->
<!--                transition="scale-transition"-->
<!--                offset-y-->
<!--                full-width-->
<!--                min-width="290px"-->
<!--        >-->
<!--          <template slot="activator" slot-scope="{ on }">-->
<!--            <v-text-field v-model="publicationTime"-->
<!--                          :label="$t('pages.questionnaireSettings.publicationTime')"-->
<!--                          prepend-icon="access_time"-->
<!--                          readonly-->
<!--                          v-on="on"-->
<!--                          color="valid"-->
<!--            />-->
<!--          </template>-->
<!--          <v-time-picker format="24hr"-->
<!--                         v-if="timePickerDisplay"-->
<!--                         v-model="publicationTime"-->
<!--                         no-title-->
<!--                         @click:minute="timePickerDisplay=false"-->
<!--                         color="valid"-->
<!--          />-->
<!--        </v-menu>-->

        <v-switch v-model="newQuestionnaire.isPublished"
                  :label="$t('pages.questionnaireSettings.isPublished')"
                  color="valid"
                  @change="autoFillDate"
        />
      </div>
      <div class="button-group">
        <v-btn color="valid"
               @click="saveInit"
        >{{ $t('components.buttons.save') }}
        </v-btn>
        <v-btn color="cancel" @click="$router.push({ name: 'questionnaireList' })">
          {{ $t('components.buttons.cancel') }}
        </v-btn>
      </div>
    </section>
  </div>
</template>

<script>
import DateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'questionnaireSettings',
  components: {
    DateTimePicker
  },
  watch: {
    publicationDayAndTime (newValue) {
      const dayAndTime = newValue.split(' ')
      this.publicationDay = dayAndTime[0]
      this.publicationTime = dayAndTime[1]
    }
  },
  data () {
    return {
      essai: null,
      /**
       * @type {QuestionnaireAir}
       */
      newQuestionnaire: {},
      datePickerDisplay: false,
      timePickerDisplay: false,
      publicationDayAndTime: null,
      publicationTime: null,
      publicationDay: null,
      duplicateLabel: '',
      isDuplication: this.$route.name === 'questionnaireDuplication',
      isUpdate: this.$route.name === 'questionnairePublication'
    }
  },
  computed: {
    ...mapGetters('Questionnaires', [
      'questionnaire',
      'questionnaireSettings'
    ]),
    ...mapGetters('Repositories', [
      'repositorySelectedId'
    ]),
    title () {
      return this.isUpdate
        ? this.$t('pages.questionnaireSettings.title.update',
          { label: this.questionnaire.label })
        : this.isDuplication
          ? this.$t('pages.questionnaireSettings.title.duplicate',
            { label: this.duplicateLabel })
          : this.$t('pages.questionnaireSettings.title.create')
    }
  },
  async created () {
    this.isUpdate ? await this.questionnaireLoad(this.$route.params.id)
      : this.isDuplication
        ? await this.questionnaireCopy(this.$route.params.id)
        : this.questionnaireInit(this.repositorySelectedId)

    this.newQuestionnaire = { ...this.questionnaireSettings }

    if (this.newQuestionnaire.publicationDate) {
      const pubDate = new Date(this.newQuestionnaire.publicationDate)
      this.setPublicationDay(pubDate)
      this.setPublicationTime(pubDate)
    }
    this.duplicateLabel = this.newQuestionnaire.label.slice(9)
  },
  methods: {
    ...mapActions('Questionnaires', [
      'questionnaireInit',
      'questionnaireCopy',
      'questionnaireLoad',
      'saveCopy',
      'questionnaireSave'
    ]),
    async saveInit () {
      this.setQuestionnaireDate()
      if (this.isDuplication) {
        await this.saveCopy(this.newQuestionnaire)
      } else {
        await this.questionnaireSave({
          questionnaire: this.newQuestionnaire,
          isUpdate: this.isUpdate
        })
      }
      if (!this.isUpdate) {
        this.$router.push({
          name: 'questionnaireCreation',
          params: { id: this.questionnaire.id }
        })
      }
    },
    setQuestionnaireDate () {
      const offsetMin = -new Date().getTimezoneOffset()
      const offsetHour = (Math.sign(offsetMin) >= 0 ? '+' : '') +
        String(Math.floor(offsetMin / 60)).padStart(2, '0') +
        ':' + String(offsetMin % 60).padStart(2, '0')
      const time = this.publicationTime !== null
        ? this.publicationTime
        : '00:00'
      this.newQuestionnaire.publicationDate = this.publicationDay !== null
        ? `${this.publicationDay}T${time}${offsetHour}`
        : null
    },
    setPublicationDay (dateTime = new Date()) {
      this.publicationDay = [dateTime.getFullYear(), dateTime.getMonth() + 1, dateTime.getDate()]
        .map(dateItem => String(dateItem).padStart(2, '0'))
        .join('-')
    },
    setPublicationTime (dateTime = new Date()) {
      this.publicationTime = [dateTime.getHours(), dateTime.getMinutes()]
        .map(dateItem => String(dateItem).padStart(2, '0'))
        .join(':')
    },
    autoFillDate () {
      if (this.newQuestionnaire.isPublished) {
        if (this.publicationDay === null) {
          this.setPublicationDay()
        }
        if (this.publicationTime === null) {
          this.setPublicationTime()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppErnest";
  #app__ernest {
    .v-progress-linear {
      margin: 0;
    }

    .date-time-picker::v-deep {
      z-index: 2000;

      .header-picker {
        div, span {
          color: white;
        }
      }

      button.active .time-picker-column-item-text {
        color: white;
      }

      button.time-picker-column-item:hover .time-picker-column-item-text {
        color: #3A3A3A;
      }
    }

    .button-group {
      margin-top: 30px;
      display: flex;
      flex-direction: column;

      .v-btn{
        margin: 15px 30px;

        &:last-child {
          margin-top: 0;
        }
      }
    }
  }
</style>
